var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"d-flex primary--text"},[_c('Icon',{staticClass:"pr-2",attrs:{"name":_vm.text.toLowerCase(),"color":_vm.$vuetify.theme.themes.light.primary,"title":_vm.text}}),_c('h3',{staticClass:"text-no-wrap"},[_vm._v(_vm._s(_vm.text))])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }